import { Link } from '@siemens/element-ng/link';

export const footerItems: Link[] = [
    {
        target: '_blank',
        href: 'https://www.siemens.com/global/en/general/legal.html',
        title: 'footer.corporate-information'
    },
    {
        target: '_blank',
        href: 'https://siemens.com/global/en/general/privacy-notice.html',
        title: 'footer.privacy-notice'
    },
    {
        target: '_blank',
        href: 'https://www.siemens.com/global/en/general/cookie-notice.html',
        title: 'footer.cookie-notice'
    },
    {
        target: '_blank',
        href: 'https://www.siemens.com/global/en/general/terms-of-use.html',
        title: 'footer.terms-of-use'
    },
    {
        target: '_blank',
        href: 'https://siemens.com/global/en/general/digital-id.html',
        title: 'footer.digital-id'
    }
];

export const footerCopyright: string = 'Siemens AG ' + new Date().getFullYear();
